import { useSelector } from "react-redux";
import Link from "next/link";
import styles from "./index.module.scss";

export default function ServicesNewItems({ services, subPage = "" }) {
  const { cityName } = useSelector((state) => state.location);
  const basePath = "services";

  return (
    <div className={styles.Services}>
      {services.map((service) => (
        <Link href={`${subPage}/${basePath}/${service.code}`} key={service.id}>
          <a className={styles.Service} data-test="serviceItem">
            <div className={styles.Image}>
              <img
                src={service.image}
                alt={service.name}
                title={service.name}
              />
            </div>
            <div className={styles.Info}>
              <div className={styles.Name}>{service.name}</div>
              <div
                className={styles.Text}
                dangerouslySetInnerHTML={{
                  __html: service.description,
                }}
              ></div>
            </div>
          </a>
        </Link>
      ))}
      {services.length === 0 && <span>В г.{cityName} нет доступных услуг</span>}
    </div>
  );
}
